import { render } from "./expense-table.vue?vue&type=template&id=21ebae9a"
import script from "./expense-table.vue?vue&type=script&lang=js"
export * from "./expense-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__